import {
    ShareCenterOption,
    ShareResidentOption,
    ShareFamiliarOption,
    ShareOption,
} from '../actions/model/domain/share-option'

export class ShareOptionsUtils {
    static copyCenterRecursive(
        option: ShareCenterOption,
        changes: Partial<ShareCenterOption>
    ): ShareCenterOption {
        return {
            ...option,
            ...changes,
            suboptions: option.suboptions?.map((resident) =>
                this.copyResidentRecursive(resident, changes)
            ),
        }
    }

    static copyResidentRecursive(
        option: ShareResidentOption,
        changes: Partial<ShareResidentOption>
    ): ShareResidentOption {
        return {
            ...option,
            ...changes,
            suboptions: option.suboptions?.map((familiar) =>
                this.copyFamiliarRecursive(familiar, changes)
            ),
        }
    }

    static copyFamiliarRecursive(
        option: ShareFamiliarOption,
        changes: Partial<ShareFamiliarOption>
    ): ShareFamiliarOption {
        return {
            ...option,
            ...changes,
        }
    }

    static getSelectedNames(options?: ShareCenterOption[]): string[] {
        const selectedNames: string[] = []

        const traverse = (options?: ShareOption[]) => {
            for (const option of options ?? []) {
                if (option.checked && !selectedNames.includes(option.name)) {
                    selectedNames.push(option.name)
                } else if (option.suboptions) {
                    traverse(option.suboptions)
                }
            }
        }

        traverse(options)

        return selectedNames
    }
}
